export default __webpack_public_path__ + "static/kfar-d4a807a923f46109c89b589663672403.png";